<!--Element多选树形控件-->
<template>
	<div class="elCheckBoxTreeBody">
		<div style="padding-top:10px;align-items: center;">
			<el-input placeholder="输入关键字进行过滤" v-model="filterText" size="small" style='width: 180px;margin-left: 15px;'>
			</el-input>
		</div>
		<el-scrollbar style="height:88%;width: 100%;">
			<el-tree :data="data" :expand-on-click-node="false" show-checkbox node-key="pkid" :default-checked-keys="defaultDeviceList" :props="defaultProps" @check-change="nodeClick" :highlight-current='true' default-expand-all :filter-node-method="filterNode" ref="tree">
				<span class="custom-tree-node" slot-scope="{node, data}">
			    <img src="../../../../public/static/image/elTree/1.9.png" v-show="node.data.type=='group'&&node.data.unitid!=''"/>
			 	<img src="../../../../public/static/image/elTree/2.0.png" v-show="node.data.type=='group'&&node.data.unitid==''"/>
			 	<img src="../../../../public/static/image/elTree/2.1.png" v-show="node.data.type=='virtualDevice'"/>
			 	<span style="padding-left: 5px;">{{node.label }}</span>
				</span>
			</el-tree>
		</el-scrollbar>
	</div>
</template>
<script>
	export default {
		components: {},
		props: {
			dataList: {
				type: Array,
				required: true,
				default: []
			},
		},
		data() {
			return {
				filterText: '',
				data: [],
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				defaultDevice:{},
			}
		},
		created() {},
		mounted() {
			if(!isempty(this.dataList)) {
				this.data = this.dataList
			}
		},
		destroyed() {},
		computed: {
			getResourcesByName() {
				return this.$store.resourcesStore.getters.getResourcesByName
			},
			nowVirtualDeviceList(){
				return [];//this.$store.deviceStore.state.nowVirtualDeviceList
			},
			
			defaultDeviceList() {
				let list = this.nowVirtualDeviceList
				let listDevice=[]
				let idList = []
				// if(isempty(list)) {
				// 	if(!isempty(this.dataList)) {
				// 		this.digui(this.dataList)
				// 	}
				// } else {
				// 	list.forEach(item => {
				// 		listDevice.push(item)
				// 		idList.push(item.pkid)
				// 	})
				// }
				// if(!isempty(idList)){
				// 	this.$emit('checkItem',listDevice)
				// }
				return idList
			}
		},
		watch: {
			filterText(val) {
				this.$refs.tree.filter(val);
			},
			dataList(nv, ov) {
				if(!isempty(nv)) {
					this.data = this.dataList;
				}
			}
		},
		methods: {
			cleanTree(){
				this.$refs.tree.setCheckedKeys([]);
			},
			setSelectedItems(selectedDev){
				this.$refs.tree.setCheckedKeys(selectedDev);
			},
			filterNode(value, data) {
				if(!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			nodeClick() {
				let list = this.$refs.tree.getCheckedNodes()
				list.forEach(item => {
					item.name = item.lable
				})
				this.$emit('checkItem',list)
			},
			digui(list) {
				list.forEach(item => {
					if(!isempty(item.children)) {
						this.digui(item.children)
					} else {
						if(item.type == 'virtualDevice') {
							if(isempty(this.nowVirtualDeviceList)){
								this.$store.deviceStore.commit('setNowVirtualDeviceList',[item] )
							}
						}
					}
				})
			}
		}
	}
</script>

<style>
	.elCheckBoxTreeBody {
		height: 99.8%;
		background-color: white;
		width: 2.5rem;
		border: 1px solid #ded7d7;
	}
	
	.elCheckBoxTreeBody .el-scrollbar .el-scrollbar__wrap {
		overflow-x: hidden;
	}
	
	.el-tree {
		margin-top: 5px;
	}
	
	.el-tree-node :nth-child(2) {
		padding: 1px;
		overflow: visible;
	}
	.elCheckBoxTreeBody .el-checkbox__inner{
		border: 1px solid #797a7c;
	}
</style>